export default __webpack_public_path__ + "static/media/loginLogo.3bc54b1b.svg";